import {
    DEALERDELETEUSERMASTER_SUCCESS,
    DEALERDELETEUSERMASTER_FAILED,
    RESET_DEALERDELETEUSERMASTER,
    LOADING_DEALERDELETEUSERMASTER,
    NETWORK_ERROR_DEALERDELETEUSERMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERDELETEUSERMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERDELETEUSERMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERDELETEUSERMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERDELETEUSERMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERDELETEUSERMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
